import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import hero from '../assets/LINK-Fotografie-1806_47909.jpg';
import card1 from '../assets/bg-hbo-bedrijfskunde.jpg';
import card2 from '../assets/bg-samenwerkingspartners-1.jpg';
import card3 from '../assets/bg-mba-gamesindustrie.jpg';
import card4img from '../assets/LINK-Fotografie-1806_47909.jpg';
import card5img from '../assets/bg-post-hbo-financial-controller.jpg';
import './OverNLBA.css';

const cards = [
  {
    to: '/over-nlba/waarom-kies-je-voor-ons',
    title: 'Waarom kies je voor ons',
    description: 'Ontdek waarom werkende professionals voor NLBA kiezen.',
    img: card1
  },
  {
    to: '/over-nlba/accreditatie',
    title: 'Accreditatie',
    description: 'Lees over kwaliteitsborging en erkende onderwijsstandaarden.',
    img: card2
  },
  {
    to: '/over-nlba/reviews',
    title: 'Reviews',
    description: 'Ervaringen en verhalen van studenten en alumni.',
    img: card3
  },
  {
    to: '/over-nlba/ons-team',
    title: 'Ons Team',
    description: 'Maak kennis met management en staf, docenten en commissies van NLBA Suriname.',
    img: card4img
  },
  {
    to: '/over-nlba/organogram',
    title: 'Organogram',
    description: 'Bekijk hoe NLBA Suriname organisatorisch is opgebouwd.',
    img: card5img
  }
];

const OverNLBA = () => {
  return (
    <div className="over-nlba-page">
      <Navbar />
      <section className="over-nlba-section">
        <div className="over-nlba-container">
          <div className="over-nlba-hero">
            <div>
              <h1>Over NLBA</h1>
              <p>
                Netherlands Business Academy Suriname is een business school voor
                werkende professionals. Vanuit praktijkgericht onderwijs helpen we
                studenten doorgroeien in leiderschap, management en ondernemerschap.
              </p>
            </div>
            <img src={hero} alt="Over NLBA" />
          </div>

          <div className="over-nlba-grid">
            {cards.map((card) => (
              <Link key={card.to} to={card.to} className="over-nlba-card">
                <img src={card.img} alt={card.title} />
                <div className="over-nlba-card-body">
                  <h3>{card.title}</h3>
                  <p>{card.description}</p>
                  <span className="over-nlba-link">Bekijk pagina {'->'}</span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default OverNLBA;
